import { Link } from "react-router-dom";

export const Logo = ({ className = "", onClick }) => {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-2.5 ${className}`}
    >
      <span className="relative grid h-9 w-9 place-items-center">
        <svg viewBox="0 0 40 40" className="h-9 w-9" fill="none" aria-hidden>
          <defs>
            <linearGradient id="auraA" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
              <stop stopColor="#FF2A85" />
              <stop offset="0.35" stopColor="#D800C3" />
              <stop offset="0.7" stopColor="#8A2BE2" />
              <stop offset="1" stopColor="#0055FF" />
            </linearGradient>
          </defs>
          <path
            d="M20 4 34 34h-7.5L20 18.5 13.5 34H6L20 4Z"
            fill="url(#auraA)"
          />
          <circle cx="20" cy="26" r="3.4" fill="url(#auraA)" />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl font-bold tracking-tight text-aura-ink">
          aura<span className="grad-text">live</span>
        </span>
        <span className="mt-0.5 text-[8px] font-bold uppercase tracking-[0.24em] text-aura-muted">
          See anywhere · Connect everywhere
        </span>
      </span>
    </Link>
  );
};
